import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import Button from '../../../../../../components/global/Button';
import { UPDATE_ROSTER_IDENTITY_MODAL } from '../../../../../../constants/modals';
import UserAddIcon from '../../../../../../components/icons/UserAddIcon';
import ImportIcon from '../../../../../../components/icons/ImportIcon';
import TrashIcon from '../../../../../../components/icons/TrashIcon';
import { ADDRESS_BOOOK_CSV_UPLOAD_MODAL } from '../AddressBookCSVUpload';
import useWaldogramsForBusinessEvent from '../../../../services/analytics/useWaldogramsForBusinessEvent';
import useAccountCardCreations from '../../../AccountCards/hooks/useAccountCardCreations';
import useBasename from '../../../../../../components/routing/useBasename';
import DraftWaldogramsIcon from '../../../../../../components/icons/DraftWaldogramsIcon';
import DropdownMenu from '../../../../../../components/global/DropdownMenu';
import Angle from '../../../../../../components/global/Angle';
import { canAccessAddressBookFilterModal } from '../../../../../../util/product-permissions';
import { ADDRESS_BOOK_FILTERS_MODAL } from '../AddressBookFilters';

const propTypes = {
  openModal: PropTypes.func.isRequired,
  onSelectableToggle: PropTypes.func,
  onRemovableToggle: PropTypes.func,
  selectable: PropTypes.bool,
  canSelect: PropTypes.bool,
  canRemove: PropTypes.bool,
  hideForModalVersion: PropTypes.bool,
};

const AccountAddressBookHeader = ({
  openModal,
  onSelectableToggle,
  onRemovableToggle,
  selectable,
  canSelect,
  canRemove,
  hideForModalVersion,
}) => {
  const history = useHistory();
  const basename = useBasename();
  const { sentAccountCards } = useAccountCardCreations({ limit: 1 });
  const trackEvent = useWaldogramsForBusinessEvent();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const useFilterModal = canAccessAddressBookFilterModal(basename);

  if (useFilterModal && hideForModalVersion) {
    return null;
  }

  return (
    <div className="address-book-header-wrapper">
      <div className="address-book-header">
        <div className="address-book-header-actions">
          {selectable && (
            <Button
              btnStyle="link"
              className="d-flex align-items-center text-primary address-book-header-link"
              onClick={onSelectableToggle}
            >
              Cancel selection
            </Button>
          )}

          {useFilterModal && (
            <Button
              btnStyle="link"
              className="d-flex align-items-center text-primary address-book-header-link ml-2"
              onClick={() => {
                openModal(ADDRESS_BOOK_FILTERS_MODAL);
              }}
            >
              Filter contacts
            </Button>
          )}

          <div className="dropdown-menu-dark ml-1">
            <DropdownMenu
              placement="bottom-end"
              closeOnClickWithin
              onToggleSuccess={() => {
                if (!selectable) {
                  setDropdownOpen(!dropdownOpen);
                }
              }}
              toggleClassName={`text-primary ${selectable ? 'disabled' : ''}`}
              className="d-flex align-items-center"
              toggle={
                <span
                  className={selectable ? 'disabled-dropdown-toggle' : ''}
                  onClick={e => {
                    if (selectable) {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                >
                  Manage contacts
                  <Angle
                    direction={dropdownOpen ? 'up' : 'down'}
                    className="ml-1"
                  />
                </span>
              }
            >
              <Button
                btnStyle="reset"
                className="dropdown-item d-flex align-items-center"
                onClick={() => {
                  openModal(UPDATE_ROSTER_IDENTITY_MODAL, {
                    modalTitle: 'Create Contact',
                  });
                }}
              >
                <UserAddIcon color="#ffffff" size={14} className="mr-1" />{' '}
                Create contact
              </Button>

              <Button
                btnStyle="reset"
                className="dropdown-item d-flex align-items-center"
                onClick={() => {
                  openModal(ADDRESS_BOOOK_CSV_UPLOAD_MODAL);
                  trackEvent({
                    action: 'CSV Upload',
                    label: 'Address Book',
                  });
                }}
              >
                <ImportIcon color="#ffffff" size={14} className="mr-1" />
                Import contacts
              </Button>

              {canSelect && onSelectableToggle && (
                <Button
                  btnStyle="reset"
                  className="dropdown-item d-flex align-items-center"
                  onClick={onSelectableToggle}
                >
                  <DraftWaldogramsIcon
                    color="#ffffff"
                    size={14}
                    className="mr-1"
                  />{' '}
                  Send Waldograms
                </Button>
              )}

              {canRemove && onRemovableToggle && (
                <Button
                  btnStyle="reset"
                  className="dropdown-item d-flex align-items-center"
                  onClick={onRemovableToggle}
                >
                  <TrashIcon color="#ffffff" size={14} className="mr-1" />{' '}
                  Remove contacts
                </Button>
              )}

              {sentAccountCards?.total > 0 && (
                <Button
                  btnStyle="reset"
                  className="dropdown-item d-flex align-items-center"
                  onClick={() =>
                    history.push(`/app/${basename}/account/cards/list`)
                  }
                >
                  <DraftWaldogramsIcon
                    color="#ffffff"
                    size={14}
                    className="mr-1"
                  />{' '}
                  View previously sent Waldograms
                </Button>
              )}
            </DropdownMenu>
          </div>
        </div>
      </div>
    </div>
  );
};

AccountAddressBookHeader.propTypes = propTypes;

export default AccountAddressBookHeader;
